var _path, _line, _line2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdminCardTotalMessages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 10,
    x2: 15,
    y2: 10,
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 14,
    x2: 12,
    y2: 14,
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminCardTotalMessages);
export default __webpack_public_path__ + "static/media/admin-card-total-messages.8cbc6ceb53817dd909b3cf1b7cc1f6d4.svg";
export { ForwardRef as ReactComponent };